import { render, staticRenderFns } from "./selectionView.vue?vue&type=template&id=2e67bdfc&scoped=true"
import script from "./selectionView.vue?vue&type=script&lang=js"
export * from "./selectionView.vue?vue&type=script&lang=js"
import style0 from "./selectionView.vue?vue&type=style&index=0&id=2e67bdfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e67bdfc",
  null
  
)

export default component.exports